export class MessageDetail {
    uniqueId: string = "'";
    icon: string = "";
    message: string = "";
    statusText: string = "";

    constructor(uniqueId: string, message: string, icon: string) {
        this.uniqueId = uniqueId;
        this.message = message;
        this.icon = icon;
    }
}

export class MessageDetails {
    details: MessageDetail[] = [];

    constructor() {
    }

    /**
     * Clear the contents of the details
     */
    clear() {
        this.details.splice(0, this.details.length);
    }
    /** 
     * Add a entry to the details
     */
    add(uniqueId: string, message: string, icon: string): void {
        this.details.push(new MessageDetail(uniqueId, message, icon));
    }
    /** 
     * Delete a details entry
     */
    delete(index: number) {
        this.details.splice(index, 1);
    }
    /**
     * Find a detail item by a unique id set in the detail by the creator
     * @param uniqueId Find the 'uniqueId' in the details array
     * @return detail item for the 'uniqueId'
     */
    find(uniqueId: string) {
        return this.details.find(d => d.uniqueId == uniqueId);
    }
}
